module.exports = __webpack_public_path__ + "front/img/btn2.b8a2fc64.png";